module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/vi_3-3f03addf035dc7b15a16c692b2c5bb64.jpg";